import { ensureAdminShellPath } from "../config/routePrefixes";

export function getTranslation(pageName, data) {
  let final = {};
  if (!data || data.length === 0) return {};
  data[0]?.languages?.forEach((zone) => {
    if (zone.page === pageName) {
      final = zone.values || {};
    }
  });
  return final;
}

export function getField(dictionary, fieldName, language, fallback) {
  if (!dictionary || Object.keys(dictionary).length === 0) return fallback || "";
  return dictionary?.[fieldName]?.[language]
    ? dictionary[fieldName][language]
    : dictionary?.[fieldName]?.english
      ? dictionary[fieldName].english
      : dictionary?.[fieldName] || fallback || "";
}

export function handleNotificationClick(clickAction, setSelectedRest, history, setNotificationOpen) {
  if (clickAction === "view-new-notifications") {
    if (setNotificationOpen) {
      setNotificationOpen(true);
    }
    return;
  }

  let url = "/";
  clickAction.split("/").forEach((str, i) => {
    if (i !== 0 && i !== 1 && i !== 2) {
      url += str + "/";
    }
  });

  url = url.replace(/\/$/, "");

  const urlParts = url.split("/").filter((part) => part !== "");

  let restaurantUuid = null;
  if (urlParts.length > 0) {
    switch (urlParts[0]) {
      case "messaging":
        if (urlParts[1]) {
          restaurantUuid = urlParts[1];
        }
        break;
      default:
        break;
    }
  }

  if (restaurantUuid && setSelectedRest) {
    setSelectedRest(restaurantUuid);

    setTimeout(() => {
      if (history) {
        const navPath = url === "/" || url.startsWith("/") ? url : `/${url}`;
        history.push(ensureAdminShellPath(navPath));
      }
    }, 100);
  } else if (history) {
    const navPath = url === "/" || url.startsWith("/") ? url : `/${url}`;
    history.push(ensureAdminShellPath(navPath));
  }
}
